<table mat-table [dataSource]="dataSource" matSort style="width: 100%;" matSortActive="name" matSortDirection="asc">

  <!-- name Column -->
  <ng-container matColumnDef="name">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.name' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.name }}</span>
    </td>
  </ng-container>

  <!-- eni Column -->
  <ng-container matColumnDef="eni">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.eni' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.eni }}</span>
    </td>
  </ng-container>

  <!-- modifiedDate Column -->
  <ng-container matColumnDef="modifiedDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.modifiedDate' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.modifiedDate | date : 'dd/MM/yyyy HH:mm'}}</span>
    </td>
  </ng-container>

  <!-- userName Column -->
  <ng-container matColumnDef="userName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.user' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.userName }}</span>
    </td>
  </ng-container>

  <!-- action Column -->
  <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header> </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="primary" (click)="editElement(element)" style="margin-right: 10px;">
        <mat-icon>edit</mat-icon>
        {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="onDelete(element)"
      *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
        <mat-icon>delete</mat-icon>
        {{ 'button.delete' | translate }}
      </button>

    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>
<mat-paginator #MatPaginatorSiteMode class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons>
</mat-paginator>